export default {
  id: 207,
  title: 'Target #207 - Green Lantern logo',
  url: 'https://cssbattle.dev/play/207',
  colors: ['#0E532F', '#70CEAF'],
  solution:
    '<p a><p b><style>body{background:#70ceaf}p{position:fixed;margin:0}p[a]{top:10;left:60;width:280;height:280;border-radius:9in;box-shadow:inset 0 0 0 25px #0e532f,inset 0 0 0 70px #70ceaf,inset 0 0 0 95px #0e532f}p[b]{top:70;left:130;width:140;height:25;background:#0e532f;box-shadow:0 135px #0e532f',
}
